import React, { useState, useEffect } from "react";
import { IonBadge, IonCheckbox, IonIcon } from "@ionic/react";

import "./GroupSmsAccordion.scss";
import { CONSTANTS } from "../../../../constants";
import { doctorListInputData } from "../../../../components/Shared/DoctorList/doctor-list.model";
import _, { isEmpty } from "lodash";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import DoctorList from "../../DoctorList/doctor-list";
import { chevronDownOutline, chevronForwardOutline } from "ionicons/icons";
import { DoctorDataModel } from "../../DoctorList/Components/DoctorCard/doctor-card.model";
import NoResults from "../../NoResults/NoResultsComponent";
interface accordionProps {
  isCheckedAll?: boolean;
  getAllStatus?: any;
  accordionList: any;
  isSelectAll: boolean;
  searchText: string;
  isFromEMSCaseDetails?: any;

  getSelectedCard: (data: Array<DoctorDataModel>) => void;
}

const GroupSmsAccordion: React.FC<accordionProps> = (props) => {
  const [scheduleList, setScheduleList]: any = useState([]);
  const [scheduleResponse, setScheduleResponse]: any = useState([]);
  const [ownGroupList, setOwnGroupList]: any = useState([]);
  const [doctorListInput, setDoctorListInput]: any = useState({});
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [apiParams, setApiParams]: any = useState({});
  const [selectedAllStatus, setSelectedAllStatus] = useState(false);

  const [selectedDoctors, setSelectedDoctors]: any = useState([]);
  const [selectedCardsToParent, SetSelectedCardsToParent]: any = useState([]);
  const [isShowNoResults, setShowNoResults] = useState(false);

  const [doctorCardList, setDoctorCardList]: any = useState([]);

  useEffect(() => {
    setAccordion();
    setDoctorListInputData();
  }, [props.accordionList]);

  useEffect(() => {
    if (!_.isEmpty(scheduleList)) {
      handleSelectAll(props.isSelectAll);
    }
  }, [props.isSelectAll]);

  useEffect(() => {
    if (props.isCheckedAll) {
      for (var i = 0; i < scheduleList.length; i++) {
        scheduleList[i].scheduleAllSelected = true;
      }
    } else {
      for (var i = 0; i < scheduleList.length; i++) {
        scheduleList[i].scheduleAllSelected = false;
      }
    }
  }, [props.isCheckedAll]);

  useEffect(() => {
    if (!_.isEmpty(props.searchText)) {
      openAllAccordionOnSearch();
    }
  }, [props.searchText]);

  useEffect(() => {
    if (selectedAllStatus) {
      handleSelectAll(true);
    }
  }, [selectedAllStatus]);

  useEffect(() => {
    // props.getSelectedCard(_.cloneDeep(selectedCardsToParent));
  }, [selectedCardsToParent]);

  const getAllCards = (data: any) => {
    setDoctorCardList(data);
  };

  const handleSelectAll = (isSelectAll: boolean) => {
    let tempScheduleList = [...scheduleList];
    getAllCards(doctorCardList);
    tempScheduleList.forEach((item: any) => {
      let selectedScheduleName = doctorCardList.map((i: any) => {
        return i.scheduleName;
      });

      tempScheduleList.find((list: any) => {
        if (list.scheduleName === selectedScheduleName[0]) {
          return (list.scheduleAllSelected = isSelectAll);
        }
      });
    });
    let doctorList:any =tempScheduleList?.map((schedule:any)=>{
      return schedule?.scheduleDoctorList
    })
    // props.getSelectedCard(doctorList?.flat())
    setScheduleList(tempScheduleList);
  };

  useEffect(() => {
    if (!_.isEmpty(scheduleList)) {
      handleDoctorsInitialSelection();
    }
  }, [scheduleList]);

  const handleDoctorsInitialSelection = () => {
    let tempScheduleList: any = [];
    scheduleList.forEach((scheduleItem: any) => {
      tempScheduleList[scheduleItem.scheduleName] = [];
    });
    setSelectedDoctors(tempScheduleList);
  };

  const setAccordion = () => {
    const ownGroupList = props.accordionList?.own
      ? Object.keys(_.cloneDeep(props.accordionList?.own))
      : [];
    const scheduleResponse = {
      ...props.accordionList?.own,
      ...props.accordionList?.added,
    };
    SetScheduleBadgeCount(scheduleResponse);
    setOwnGroupList(ownGroupList);
    setScheduleResponse(scheduleResponse);
  };

  const SetScheduleBadgeCount = (scheduleResponse: any) => {
    if (!_.isEmpty(scheduleResponse)) {
      let ScheduleResponseArray = Object.keys(scheduleResponse).map(
        (key: any) => {
          return {
            scheduleName: key,
            scheduleDoctorList: scheduleResponse[key].data,
            scheduleBadgeCount: scheduleResponse[key].data.length,
            scheduleAllSelected: false,
          };
        }
      );
      // sorting array based on providers on call length
      ScheduleResponseArray.sort(
        (arrayItem1: any, arrayItem2: any) =>
          arrayItem2.scheduleBadgeCount - arrayItem1.scheduleBadgeCount
      );
      setScheduleList(ScheduleResponseArray);
    }
  };

  const setDoctorListInputData = () => {
    const doctorListInput: doctorListInputData = {
      componentName: CONSTANTS.COMPONENTS.GROUP_SMS,
      isMultiSelectEnabled: true,
      isShowColorBadge: false,
    };
    setDoctorListInput(doctorListInput);
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  };

  const isOwnGroup = (scheduleName: string) => {
    if (ownGroupList && ownGroupList.length !== 0) {
      return ownGroupList.indexOf(scheduleName) !== -1 ? true : false;
    } else {
      return false;
    }
  };

  const selectCurrentScheduleItem = (event: any, index: number) => {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    let tempScheduleList = [...scheduleList];
    tempScheduleList[index].scheduleAllSelected = event.detail.checked;
    
    // tempScheduleList[index]?.scheduleDoctorList?.forEach((doctor:any)=>{
    //   props.getSelectedCard(doctor)
    // })

    props.getSelectedCard(tempScheduleList[index]?.scheduleDoctorList);

    if (!_.isEmpty(tempScheduleList)) {
      setScheduleList(tempScheduleList);
    }

    const isAllSelected = tempScheduleList.every(
      (item: any) => item.scheduleAllSelected === true
    );
    if (!isAllSelected) {
      props.getAllStatus(false);
    } else if (isAllSelected) {
      props.getAllStatus(true);
    }
  };

  const getSelectedCardsAndSchedule = (
    selectedCard: any,
    scheduleName: any
  ) => {
    selectedDoctors[scheduleName] = selectedCard;
    setSelectedDoctors(selectedDoctors);
    let tempSelectedArray: any = [];
    let finalSelectedArray: any = [];
    Object.entries(selectedDoctors).forEach(([key, value]) => {
      if (!_.isEmpty(value)) {
        tempSelectedArray.push(value);
      }
    });

    if (!_.isEmpty(tempSelectedArray)) {
      tempSelectedArray.forEach((element: any) => {
        element.forEach((elementItem: any) => {
          const isObjectPresent = _.find(finalSelectedArray, {
            guid: elementItem.guid,
          });
          if (_.isEmpty(isObjectPresent)) {
            finalSelectedArray.push(elementItem);
          }
        });
      });
    }
    SetSelectedCardsToParent(_.cloneDeep(finalSelectedArray));
  };

  const getSelectAllStatus = (selectedAllStatusFromDoctorList: boolean) => {
    if (selectedAllStatusFromDoctorList) {
      handleSelectAll(true);
      setSelectedAllStatus(selectedAllStatusFromDoctorList);
    } else {
      handleSelectAll(false);
    }
  };

  const toggleAccordionContainer = (scheduleName: string) => {
    const scheduleItemContainer = document.getElementById(
      `accordion-container-${scheduleName}`
    );
    const forwardArrow = document.getElementById(
      `arrow-forward-${scheduleName}`
    );
    const downwardArrow = document.getElementById(`arrow-down-${scheduleName}`);
    if (scheduleItemContainer?.style.display === "none") {
      scheduleItemContainer?.style.setProperty("display", "");
      forwardArrow?.style.setProperty("display", "none");
      downwardArrow?.style.setProperty("display", "flex");
    } else if (scheduleItemContainer?.style.display === "") {
      scheduleItemContainer?.style.setProperty("display", "none");
      forwardArrow?.style.setProperty("display", "flex");
      downwardArrow?.style.setProperty("display", "none");
    }
  };

  const openAllAccordionOnSearch = () => {
    scheduleList.forEach((scheduleListElement: any) => {
      const scheduleItemContainer = document.getElementById(
        `accordion-container-${scheduleListElement.scheduleName}`
      );
      const forwardArrow = document.getElementById(
        `arrow-forward-${scheduleListElement.scheduleName}`
      );
      const downwardArrow = document.getElementById(
        `arrow-down-${scheduleListElement.scheduleName}`
      );
      scheduleItemContainer?.style.setProperty("display", "");
      forwardArrow?.style.setProperty("display", "none");
      downwardArrow?.style.setProperty("display", "flex");
    });
  };

  const getAllCardsAndSchedule = (allCardsList: any, scheduleName: string) => {
    // to hide a schedule if doctorcard is empty after searching
    if (allCardsList !== undefined) {
      const scheduleItemContainer = document.getElementById(
        `accordion-container-div-${scheduleName}`
      );
      if (isEmpty(allCardsList)) {
        scheduleItemContainer?.style.setProperty("display", "none");
      } else if (!_.isEmpty(allCardsList)) {
        scheduleItemContainer?.style.setProperty("display", "");
      }
    }
    //to show no results if all schedule are empty
    var allAreHidden = true;
    scheduleList.forEach((scheduleListItem: any) => {
      const scheduleItemContainer = document.getElementById(
        `accordion-container-div-${scheduleListItem.scheduleName}`
      );
      if (scheduleItemContainer?.style.display !== "none") {
        allAreHidden = false;
        return false;
      }
    });

    allAreHidden ? setShowNoResults(true) : setShowNoResults(false);
  };

  const getSelectedCard = (selectedCard: any) => {
    // props.getSelectedCard(selectedCard);
  };

  const fetchSingleCard = (card:any) =>{
    props.getSelectedCard(card);
  }

  return (
    <div
      className="group-sms-accordion-wrapper"
      id="group-sms-accordion-wrapper"
    >
      {scheduleList.map((scheduleListItem: any, index: any) => {
        return (
          <div
            className="accordion-container-div"
            id={`accordion-container-div-${scheduleListItem.scheduleName}`}
          >
            <div
              className="accordion-tab-div"
              onClick={(e) => {
                toggleAccordionContainer(scheduleListItem.scheduleName);
              }}
            >
              <div
                className={`accordion-header-badge ${
                  isOwnGroup(scheduleListItem.scheduleName)
                    ? "own-badge"
                    : "added-badge"
                }`}
              ></div>
              {!props.isFromEMSCaseDetails && (
                <div
                  className="select-all-button"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  <IonCheckbox
                    className="check-box"
                    onIonChange={(event) =>
                      selectCurrentScheduleItem(event, index)
                    }
                    checked={scheduleListItem.scheduleAllSelected}
                  ></IonCheckbox>
                </div>
              )}

              <IonBadge
                className="accordian-badge-count"
                title="Number of providers on call"
              >
                {scheduleListItem.scheduleBadgeCount}
              </IonBadge>
              <span className="tab-header-value">
                {scheduleListItem.scheduleName}
              </span>
              <IonIcon
                className="arrow-forward"
                icon={chevronForwardOutline}
                id={`arrow-forward-${scheduleListItem.scheduleName}`}
              ></IonIcon>
              <IonIcon
                icon={chevronDownOutline}
                className="arrow-down"
                id={`arrow-down-${scheduleListItem.scheduleName}`}
              ></IonIcon>
            </div>
            <div
              className="accordion-content-container"
              id={`accordion-container-${scheduleListItem.scheduleName}`}
            >
              {scheduleList &&
                !_.isEmpty(scheduleListItem.scheduleDoctorList) && (
                  <DoctorList
                    homeGroupSmsScheduleName={scheduleListItem.scheduleName}
                    apiParams={apiParams}
                    doctorListInputData={doctorListInput}
                    permissions={rolePermissions}
                    selectedAll={scheduleListItem.scheduleAllSelected}
                    searchText={props.searchText}
                    doctorListDataFromParent={
                      scheduleListItem.scheduleDoctorList
                    }
                    getSelectedCard={getSelectedCard}
                    getSelectedCardAndSchedule={getSelectedCardsAndSchedule}
                    getAllCardsAndSchedule={getAllCardsAndSchedule}
                    getIsAllSelectedStatus={getSelectAllStatus}
                    getAllCards={getAllCards}
                    hideFeatureButtons={true}
                    isFullScreen={false}
                    fetchSingleCard={fetchSingleCard}
                  ></DoctorList>
                )}
            </div>
          </div>
        );
      })}
      {scheduleList.length === 0 && props.isFromEMSCaseDetails && (
        <div className="no-teammates-available-label">
          No teammates available
        </div>
      )}
      {isShowNoResults && <NoResults></NoResults>}
    </div>
  );
};

export default GroupSmsAccordion;
